import React, { useState, useEffect } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.css";
import "../../../assets/scss/datepicker.css";
import { leaveManagamentPlaceholder } from "services/constants/PlaceHolder";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";

const DefaultMonthDateRangePicker = ({
  handleStartDate,
  showToday,
  triggerDate,
}) => {
  const [state, setState] = useState(() => {
    if (!triggerDate) {
      return {
        start: moment(),
        end: moment(),
      };
    } else {
      return {
        start: moment().startOf("month"),
        end: moment().endOf("month"),
      };
    }
  });

  const [trigger, setTrigger] = useState(true);
  const [labelName, setLabelName] = useState(
    triggerDate ? "This Month" : "Today"
  );

  useEffect(() => {
    const getPastDayDetails = () => {
      if (triggerDate) {
        const defaultStart = moment().startOf("month");
        const defaultEnd = moment().endOf("month");
        setState({ start: defaultStart, end: defaultEnd });
        setLabelName(triggerDate ? "This Month" : "Today");
        handleStartDate(
          defaultStart.format("DD/MM/YYYY"),
          defaultEnd.format("DD/MM/YYYY")
        );
      } else {
        const defaultStart = moment();
        const defaultEnd = moment();
        setState({ start: defaultStart, end: defaultEnd });
        setLabelName(triggerDate ? "This Month" : "Today");
        handleStartDate(
          defaultStart.format("DD/MM/YYYY"),
          defaultEnd.format("DD/MM/YYYY")
        );
      }
    };
    if (trigger) {
      getPastDayDetails();
      setTrigger(false);
    }
  }, [handleStartDate, trigger, triggerDate]);

  const { start, end } = state;
  const handleCallback = (start, end, rangeLabel) => {
    setState({ start, end });
    handleStartDate(
      moment(new Date(start)).format("DD/MM/YYYY"),
      moment(new Date(end)).format("DD/MM/YYYY")
    );
    setLabelName(rangeLabel);
  };
  const label = start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");

  const getRanges = () => ({
    ...(showToday && {
      Today: [moment().toDate(), moment().toDate()],
    }),
    Yesterday: [
      moment().subtract(1, "days").toDate(),
      moment().subtract(1, "days").toDate(),
    ],
    "Last 7 Days": [
      moment().subtract(7, "days").toDate(),
      moment().subtract(1, "days").toDate(),
    ],
    "Last 30 Days": [moment().subtract(29, "days").toDate(), moment().toDate()],
    "This Month": [
      moment().startOf("month").toDate(),
      moment().endOf("month").toDate(),
    ],
    "Last Month": [
      moment().subtract(1, "month").startOf("month").toDate(),
      moment().subtract(1, "month").endOf("month").toDate(),
    ],
  });

  return (
    <DateRangePicker
      initialSettings={{
        startDate: start.toDate(),
        endDate: end.toDate(),
        ranges: getRanges(),
        applyClass: "custom-apply-btn",
        cancelClass: "custom-cancel-btn",
        locale: {
          format: "DD/MM/YYYY",
        },
      }}
      onCallback={handleCallback}
    >
      <TextField
        id="reportrange"
        label={labelName}
        placeholder={leaveManagamentPlaceholder.dateFormat}
        value={label}
        size="small"
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton>
                <DateRangeIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        InputLabelProps={{ shrink: true, required: true }}
        fullWidth
      />
    </DateRangePicker>
  );
};

export default DefaultMonthDateRangePicker;
